import consentGatedInit from '@framework/cookie-consent/consentGatedInit';
import { ConsentCategory } from '@framework/cookie-consent/constants';
import { ISentryConfig } from './types';

/**
 * Defers Sentry.init() until functional consent cookie is present.
 */
export default function createCookieConsentGatedSentryConfig(config: ISentryConfig): void {
  consentGatedInit(ConsentCategory.Functional, () =>
    import('./createSentryConfig').then(({ default: createSentryConfig }) => {
      createSentryConfig(config);
    }),
  );
}
